module.exports = __webpack_public_path__ + "img/ico-4-active.95fe04f5.svg";